module.exports = __webpack_public_path__ + "img/peter.95861ba2.svg";